import { Bar, BarDatum } from "@nivo/bar";
import { StackedBarData, StackedBarItem } from "src/components/monitoring/senec-stacked-bar-chart/SenecStackedBarChart";
import { Stack, Typography, useTheme } from "@mui/material";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";

const StackedBarGroups = ({
    stackedBarData,
    width,
    maxEnergyYValue,
}: {
    stackedBarData: StackedBarData[];
    width: number;
    maxEnergyYValue: number;
}) => {
    const theme: SenecBaseTheme = useTheme();

    return (
        <>
            {stackedBarData.map((dataStack, i) => (
                <Stack direction="column" spacing="8px" useFlexGap sx={{ width }} key={i}>
                    <Bar
                        width={width}
                        height={346}
                        data={convertToBarDatumArray(dataStack.stackedBarItems, maxEnergyYValue)}
                        keys={keys}
                        indexBy="groupIndex"
                        gridYValues={[1000]}
                        maxValue={maxEnergyYValue}
                        margin={{ top: 9, right: 0, bottom: 0, left: 0 }}
                        padding={0.3}
                        groupMode="stacked"
                        isInteractive={false}
                        animate={false}
                        label={""}
                        colors={(data: { id: string | number; index: number }) =>
                            getColorByLevel(dataStack.stackedBarItems, data.index, `${data.id}`) ?? ""
                        }
                        layers={["bars"]}
                    />
                    <Typography
                        variant="body1Responsive"
                        color={theme.palette.neutralGray50.main}
                        sx={{ textAlign: "center", marginLeft: "-100%", marginRight: "-100%" }}
                    >
                        {dataStack.label}
                    </Typography>
                </Stack>
            ))}
        </>
    );
};

function convertToBarDatumArray(stackedBarItems: StackedBarItem[] | undefined, maxEnergyYValue: number): BarDatum[] {
    if (!stackedBarItems) return [];

    return stackedBarItems.map((stack) => {
        const { groupIndex, lower, middle, upper, isPercentageStack } = stack;

        return {
            groupIndex,
            lower: calculateValue(lower, isPercentageStack, maxEnergyYValue),
            middle: calculateValue(middle, isPercentageStack, maxEnergyYValue),
            upper: calculateValue(upper, isPercentageStack, maxEnergyYValue),
        };
    });
}

function calculateValue(segment: { value: number } | undefined, isPercentageStack: boolean, maxEnergyYValue: number): number {
    if (!segment) return 0;
    return isPercentageStack ? (segment.value / 100) * maxEnergyYValue : segment.value;
}

const getColorByLevel = (
    stackedBarItems: StackedBarItem[] | undefined,
    groupIndex: number,
    level: string,
): string | undefined => {
    if (groupIndex < 0 || groupIndex > 2) return "";

    if (stackedBarItems) {
        const stackedBarItem = stackedBarItems[groupIndex];

        switch (level) {
            case "lower":
                return stackedBarItem.lower?.color;
            case "middle":
                return stackedBarItem.middle?.color;
            case "upper":
                return stackedBarItem.upper?.color;
        }
    }
    return "";
};
const keys: (keyof StackedBarItem)[] = ["lower", "middle", "upper"];

export default StackedBarGroups;
